<template>
  <div class="bundle-detail-container">
    <el-main>
      <el-card class="bundle-info-card" v-if="showPrivateAlert">
        <div class="private-alert">
          <i class="el-icon-lock"></i>
          <span>Sorry. This bundle is private and not visible to visitors.</span>
          <el-button type="primary" @click="$router.push('/')" plain>Back to Home</el-button>
        </div>
      </el-card>
      
      <el-card class="bundle-info-card" v-if="!showPrivateAlert">
        <div v-if="loading" class="loading-container">
          <el-skeleton animated>
            <template>
              <div class="bundle-header">
                <div class="collections-preview">
                  <el-skeleton-item variant="image" style="width: 140px; height: 180px"/>
                </div>
                <div style="flex: 1">
                  <el-skeleton-item variant="h1" style="width: 50%"/>
                  <el-skeleton-item variant="text" style="margin-top: 16px; width: 30%"/>
                  <el-skeleton-item variant="text" style="margin-top: 16px"/>
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>

        <template v-else>
          <div class="bundle-header">
            <!-- Collections Preview -->
            <!-- <div class="collections-preview">
              
            </div> -->

            <!-- Bundle Info -->
            <div class="bundle-info">
              <div class="title-row">
                <h2>{{ bundle.bundle_name }}</h2>
                <div class="actions" v-if="isOwner">
                  <el-button 
                    type="primary" 
                    icon="el-icon-edit"
                    @click="handleEdit"
                  >
                    Edit
                  </el-button>
                  <el-button icon="el-icon-link" :disabled="!bundle.bundle_name_url_identifier" @click="copyBundleLink('slug')">
                    Copy slug link
                  </el-button>
                  <el-button icon="el-icon-link" @click="copyBundleLink('id')">
                    Copy ID link
                  </el-button>
                  <el-dropdown trigger="click" style="margin-left: 10px">
                    <el-button type="text">
                      <i class="el-icon-more" style="color: #409eff; transform: rotate(90deg);"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="handleDelete" style="color: #f56c6c;">
                        <i class="el-icon-delete"></i>
                        Delete this Collection Bundle
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>

              <div class="author">
                <span style="margin-right: 8px;">By  </span>
                <el-avatar 
                  :size="24" 
                  :src="bundle.user_avatar_address_small"
                  :style="{
                    border: '1px solid #e0e0e0',
                    backgroundColor: bundle.user_avatar_address_small && bundle.user_avatar_address_small !== '' && bundle.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                    fontSize: '14px',
                    color: '#409EFF',
                    marginRight: '8px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ bundle.user_avatar_address_small && bundle.user_avatar_address_small !== '' && bundle.user_avatar_address_small !== 'undefined' ? '' : bundle.user_name?.charAt(0) }}
                </el-avatar>
                <router-link 
                  :to="{ path: '/profile', query: { id: bundle.user_id }}" 
                  class="creator-link"
                >
                  {{ bundle.user_name }}
                </router-link>
                <span> | Last updated: {{ formatDate(bundle.update_time * 1000) }}</span>
              </div>
              <p class="description">{{ bundle.bundle_description }}</p>

              <!-- Add this new section -->
              <div class="bundle-stats">
                <div class="stat-item">
                  <i class="el-icon-folder"></i>
                  <span>{{ totalGroups }} Groups</span>
                </div>
                <div class="stat-item">
                  <i class="el-icon-document"></i>
                  <span>{{ totalKnowits }} Stacks</span>
                </div>
                <div class="stat-item">
                  <i class="el-icon-reading"></i>
                  <span>{{ totalContents }} Cards</span>
                </div>
                <div class="stat-item">
                  <i class="el-icon-question"></i>
                  <span>{{ totalQuizzes }} Quizzes</span>
                </div>
              </div>

              <div class="bundle-meta">
                <div class="price-tag">FREE</div>
              </div>

              <div class="action-row">
                <!-- Platform Subscription Badge -->
                <div v-if="hasPlatformSubscription" class="subscription-badge">
                  <i class="el-icon-check"></i>
                  <span>Included in your subscription</span>
                </div>
                <el-button
                  v-if="!isPurchased"
                  type="primary"
                  size="large"
                  @click="handlePurchase"
                >
                  Claim Free
                </el-button>
                <el-button
                  v-else
                  type="primary"
                  size="large"
                  disabled
                >
                  Claimed
                </el-button>
                <!-- Subscribe Button (for non-subscribers) -->
                <el-button
                  v-if="!hasPlatformSubscription && !isOwner"
                  type="primary"
                  class="subscribe-button"
                  @click="$router.push('/platform-subscription')"
                >
                  <i class="el-icon-star-on"></i> Subscribe for Full Access
                </el-button>
              </div>
            </div>
          </div>

          <!-- Collections List -->
          <div class="collections-section">
            <div class="meta-item">
              <h3>Decks in this Bundle</h3>
              <i class="el-icon-collection"></i>
              <span>{{ bundle.bundle_collections?.length || 0 }} Decks</span>
            </div>
            
                  
            <div class="collections-grid">
              <CollectionSimpleCard
                v-for="collection in bundle.collection_array"
                :key="getCollectionId(collection)"
                :collection="collection"
                @click="viewCollection(getCollectionId(collection))"
              />
            </div>
          </div>
        </template>
      </el-card>
    </el-main>
  </div>
</template>

<script>
import { postRequest } from '@/apis/front'
import CollectionSimpleCard from '@/components/CollectionSimpleCard.vue'
import { copyPublicContentUrl, publicContentUrl } from '@/utils/publicContentLinks'

export default {
  name: 'BundleDetail',
  components: {
    CollectionSimpleCard
  },
  data() {
    return {
      bundle: {},
      loading: true,
      isPurchased: false,
      totalPrice: 0,
      discountPercentage: 0,
      showPrivateAlert: false

    }
  },
  computed: {
    isOwner() {
      return this.bundle.user_id === this.$store.state.user_id
    },
    hasPlatformSubscription() {
      return this.$store.state.platformSubscription?.active
    },
    previewCollections() {
      if (!this.bundle.bundle_collections) return []
      return this.bundle.bundle_collections.slice(0, 3)
    },
    calculateTotalPrice() {
      if (!this.bundle.collection_array) return 0
      return Object.values(this.bundle.collection_array).reduce((total, collection) => {
        return total + this.getEffectiveCollectionPrice(collection)
      }, 0)
    },
    totalGroups() {
      if (!this.bundle.collection_array) return 0
      return Object.values(this.bundle.collection_array).reduce((total, collection) => {
        return total + (collection.group_count || 0)
      }, 0)
    },
    totalKnowits() {
      if (!this.bundle.collection_array) return 0
      return Object.values(this.bundle.collection_array).reduce((total, collection) => {
        return total + (collection.knowit_count || collection.planned_knowit_count || 0)
      }, 0)
    },
    totalContents() {
      if (!this.bundle.collection_array) return 0
      return Object.values(this.bundle.collection_array).reduce((total, collection) => {
        return total + (collection.content_count || 0)
      }, 0)
    },
    totalQuizzes() {
      if (!this.bundle.collection_array) return 0
      return Object.values(this.bundle.collection_array).reduce((total, collection) => {
        return total + (collection.quiz_count || 0)
      }, 0)
    },
  },
  methods: {
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleDateString()
    },
    getEffectiveCollectionPrice(collection) {
      if (!collection) return 0
      const rawPrice = collection.has_custom_price === true
        ? collection.usd_price
        : collection.base_credits
      const price = Number(rawPrice)
      return Number.isFinite(price) && price > 0 ? Math.round(price * 100) / 100 : 0
    },
    calculatePrices() {
      if (!this.bundle.collection_array) return
      const rawTotal = Object.values(this.bundle.collection_array).reduce((total, collection) => {
        return total + this.getEffectiveCollectionPrice(collection)
      }, 0)
      // Round to 2 decimal places to fix floating-point precision issues
      this.totalPrice = Math.round(rawTotal * 100) / 100

      if (this.totalPrice > 0 && this.bundle.bundle_usd_price > 0) {
        this.discountPercentage = Math.round(((this.totalPrice - this.bundle.bundle_usd_price) / this.totalPrice) * 100)
      }
    },
    async fetchBundleDetail() {
      this.loading = true
      try {
        const bundleId = this.$store.state.tempBundleId || this.$route.query.id
        
        if (!bundleId) {
          this.$message.error('Bundle ID not found')
          this.$router.go(-1)
          return
        }
        
        const response = await postRequest('getCollectionBundle', {
          bundle_id: bundleId,
          user_id: this.$store.state.user_id
        })
        
        if (response.data.code === 0) {
          this.bundle = response.data.data
          this.calculatePrices()
          this.checkPurchaseStatus()

          // Update URL with bundle ID so it's shareable
          const currentBundleId = this.bundle._id?.$oid || this.bundle._id?.$id
          if (currentBundleId && this.$route.query.id !== currentBundleId) {
            this.$router.replace({
              path: '/bundle',
              query: { id: currentBundleId }
            }).catch(() => {})
          }
        } else if(response.data.code === -2){
          this.showPrivateAlert = true
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch bundle details')
        }
      } catch (error) {
        console.error('Error fetching bundle details:', error)
        this.$message.error('Failed to fetch bundle details')
      } finally {
        this.loading = false
      }
    },
    async checkPurchaseStatus() {
      // TODO: Implement purchase status check
      this.isPurchased = false
    },
    handleEdit() {
      this.$router.push(`/edit-bundle/${(this.bundle._id.$oid || this.bundle._id.$id)}`)
    },
    async copyBundleLink(format) {
      try {
        await copyPublicContentUrl(publicContentUrl('bundle', this.bundle, format))
        this.$message.success(`${format === 'slug' ? 'Slug' : 'ID'} link copied to clipboard`)
      } catch {
        this.$message.error('Failed to copy link')
      }
    },
    async handleDelete() {
      try {
        await this.$confirm('Are you sure you want to delete this bundle?', 'Warning', {
          type: 'warning'
        })

        const response = await postRequest('deleteBundle', {
          bundle_id: (this.bundle._id.$oid || this.bundle._id.$id)
        })
        
        if (response.data.code === 0) {
          this.$message.success('Bundle deleted successfully')
          this.$router.go(-1)
        } else {
          this.$message.error(response.data.msg || 'Failed to delete bundle')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Error deleting bundle:', error)
          this.$message.error('Failed to delete bundle')
        }
      }
    },
    handlePurchase() {
      // Check if user has active platform subscription
      if (!this.hasPlatformSubscription) {
        this.$confirm(
          'An active platform subscription is required to claim content. Would you like to subscribe now?',
          'Subscription Required',
          {
            confirmButtonText: 'Subscribe Now',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          this.$router.push('/platform-subscription')
        }).catch(() => {})
        return
      }

      const bundleId = this.$store.state.tempBundleId || this.$route.query.id
      this.$store.dispatch('setTempBundleId', bundleId)
      this.$router.push({
        path: '/bundle-order',
        query: {
          type: 'bundle'
        }
      })
    },
    viewCollection(collectionId) {
      this.$store.dispatch('setTempCollectionId', collectionId)
      this.$router.push({ path: '/deck', query: { id: collectionId } })
    },
    getCollectionId(collection) {
      console.log("Collection Detail"+(collection.collection_id?.$oid || collection.collection_id?.$id))
      return collection?._id?.$oid || collection?._id?.$id || collection?.id || collection?.collection_id?.$oid || collection?.collection_id?.$id||`collection-${Math.random()}`
    }
  },
  beforeDestroy() {
    // Clean up the temporary bundle ID from store
    this.$store.dispatch('setTempBundleId', null)
  },
  mounted() {
    this.fetchBundleDetail()
    // Fetch platform subscription status if not already loaded
    if (!this.$store.state.platformSubscription) {
      this.$store.dispatch('fetchPlatformSubscription')
    }
  }
}
</script>

<style scoped>
.bundle-detail-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.bundle-header {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
}

.collections-preview {
  position: relative;
  width: 200px;
  height: 260px;
  flex-shrink: 0;
}

.collection-preview-item {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: transform 0.3s;
}

.collection-cover {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bundle-info {
  flex: 1;
}

.title-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.title-row .actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.title-row h2 {
  margin: 0;
  font-size: 24px;
}

.author {
  color: #606266;
  margin: 5px 0 15px;
  display: flex;
  align-items: center;
}

.description {
  font-size: 16px;
  line-height: 1.6;
  color: #303133;
  margin-bottom: 20px;
}

.bundle-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
}

.price-tag {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
}

.original-price {
  text-decoration: line-through;
  color: #909399;
  font-size: 18px;
  margin-right: 10px;
}

.discount-tag {
  font-size: 16px;
  color: #67C23A;
  margin-left: 10px;
  padding: 2px 8px;
  background-color: #f0f9eb;
  border-radius: 4px;
}

.action-row {
  margin-top: 30px;
}

.collections-section {
  margin-top: 40px;
}

.collections-section h3 {
  margin-bottom: 20px;
}

.private-alert {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;
  text-align: center;
}

.private-alert i {
  font-size: 48px;
  color: #909399;
}

.private-alert span {
  font-size: 16px;
  color: #606266;
}

.private-alert .el-button {
  margin-top: 8px;
}

.collections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
}

.loading-container {
  min-height: 400px;
}

.creator-link {
  color: #409EFF;
  margin-right: 8px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.bundle-stats {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
}

.stat-item i {
  font-size: 18px;
  color: #409EFF;
}

.subscription-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #e1f3d8 0%, #d4edda 100%);
  border: 1px solid #67c23a;
  border-radius: 20px;
  color: #67c23a;
  font-weight: 500;
  font-size: 14px;
}

.subscription-badge i {
  font-size: 16px;
}

.subscribe-button {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  border: none;
}

.subscribe-button:hover {
  background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
}

.action-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
</style>
